export default __webpack_public_path__ + "static/media/Guide.f9fba8b9.svg";